module.exports = __webpack_public_path__ + "assets/order-by-asc.9468dbca.svg";